var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"biography-star",attrs:{"viewBox":"0 0 32 32","fill":"none","stroke":"currentColor","stroke-width":"3","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":"M16 2v28M2 16h28M6 6l20 20M6 26L26 6"}})])}
var staticRenderFns = []

export { render, staticRenderFns }